import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Reports a page view on every route change. Fire-and-forget: analytics must
 * never delay rendering or surface an error to the visitor.
 */
export function usePageView(): void {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith('/admin')) return;

    const timer = window.setTimeout(() => {
      fetch('/api/track', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ path: pathname }),
        keepalive: true,
      }).catch(() => undefined);
    }, 1200);

    return () => window.clearTimeout(timer);
  }, [pathname]);
}
